<script>
  import Pagination from '@/components/pagination/index.vue';
  import BaseListLayout from '@/views/layout/components/BaseListLayout.vue';
  import { myMixin } from '@/mixins/mixins.js';
  import { handleSortItem } from 'utils/utils';
  import { billingEnumMixins } from '@/mixins/billingEnumMixins';
  import { userInfoMixin } from '@/mixins/userInfoMixin';
  import { financeInfoMixins } from '@/mixins/financeInfoMixins';
  import AdvPaymentReceiptCreateForm from '@/views/billing/advertiser/forms/AdvPaymentReceiptCreateForm.vue';
  import { roleUserMixins } from '@/mixins/roleUserMixins';
  import GroupSelect from '@/components/GroupSelect/index.vue';
  import AdvPaymentReceiptConfirmForm from '@/views/billing/advertiser/forms/AdvPaymentReceiptConfirmForm.vue';
  import { addNumber, divideNumber } from 'utils/number';
  import { numToPercentStr } from 'utils/string';
  import { getAdvReceiptClaimList } from 'api/billing/advertiser/advReceiptClaimAPI';
  import AttachmentPopoverTable from '@/components/common/AttachmentPopoverTable.vue';

  export default {
    name: 'AdvPaymentReceiptApp',
    components: {
      AttachmentPopoverTable,
      AdvPaymentReceiptConfirmForm,
      AdvPaymentReceiptCreateForm,
      GroupSelect,
      BaseListLayout,
      Pagination,
    },
    mixins: [myMixin, billingEnumMixins, userInfoMixin, financeInfoMixins, roleUserMixins],
    data() {
      return {
        createDialogVisible: false,
        confirmDialogVisible: false,
        total: 0,
        listLoading: false,
        dataList: [],
        receiptClaimStatus: null,
        confirmFormReceiptType: '',
        filter: {
          page: 1,
          pageSize: 10,
          advCompanyPlatform: null,
          advReceiptClaimNumber: null,
          affEntity: null,
          pmId: null,
          bdId: null,
          hyperTapEntityId: null,
          receiptClaimStatus: null,
          currency: null,
          receiptType: null,
          receiptStatus: null,
          receiptDate: null,
          recordDateRange: [],
          sortItems: [],
        },
      };
    },
    mounted() {
      this.handleSearch();
    },
    methods: {
      numToPercentStr,
      divideNumber,
      addNumber,
      handleSizeChange(size) {
        this.filter.pageSize = size;
        this.handleSearch(1);
      },
      handleCurrentChange(currentPage) {
        this.filter.page = currentPage;
        this.handleSearch(currentPage);
      },
      handleSort(columnInfo) {
        const sortItem = handleSortItem(columnInfo);
        if (sortItem === '') {
          return;
        }
        this.filter.sortItems = [];
        this.filter.sortItems.push(sortItem);
        this.handleSearch(1);
      },
      handleSearch(page) {
        if (page) {
          this.filter.page = page;
        }
        this.listLoading = true;
        getAdvReceiptClaimList(this.filter)
          .then((res) => {
            if (res) {
              const result = res.result;
              this.dataList = result.dataList;
              this.total = res.total;
              this.$nextTick(() => {
                this.$refs.tableRef.doLayout();
              });
            }
          })
          .catch(() => {})
          .finally(() => {
            this.listLoading = false;
          });
      },
      handleForm(receiptClaimStatus, confirmFormReceiptType) {
        this.confirmFormReceiptType = confirmFormReceiptType;
        this.receiptClaimStatus = receiptClaimStatus;
        this.confirmDialogVisible = true;
      },
    },
  };
</script>

<template>
  <base-list-layout :title="'Adv Payment Receipt Management'">
    <template #search>
      <el-form :inline="true" :model="filter" label-width="180px" ref="searchForm">
        <el-form-item label="Date">
          <el-date-picker
            v-model="filter.recordDateRange"
            format="yyyy-MM"
            value-format="yyyy-MM"
            type="monthrange"
            clearable
            style="width:260px;"
            align="right"
            unlink-panels
            range-separator="to"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="monthPickerOptions"
          />
        </el-form-item>
        <el-form-item label="Application Number">
          <el-input v-model="filter.advReceiptClaimNumber" />
        </el-form-item>
        <el-form-item label="Company Platform">
          <el-select
            v-model="filter.advCompanyPlatform"
            filterable
            clearable
            @change="handleCompanyPlatformChange(filter.advCompanyPlatform)"
          >
            <el-option
              v-for="item in companyPlatformList"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Adv Entity">
          <el-select v-model="filter.advEntity" ref="companyEntityOptions" filterable clearable>
            <el-option
              v-for="item in specificCompanyEntity"
              :key="item.id"
              :label="item.companyEntity"
              :value="item.companyEntity"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="HyperTap Entity">
          <div class="row-multi-item">
            <el-select v-model="filter.hyperTapEntityId" filterable clearable>
              <el-option
                v-for="item in hyperTapCompanyEntities"
                :key="item.bfiId"
                :label="item.companyEntityAlias"
                :value="item.bfiId"
              />
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="PM">
          <el-select v-model="filter.pmId" filterable clearable>
            <el-option
              v-for="item in allPmList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="BD">
          <el-select v-model="filter.bdId" filterable clearable>
            <el-option
              v-for="item in allBdList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Advertiser">
          <group-select
            v-model="filter.advIdList"
            :data-source="sourcesList"
            multiple
            :loading="sourceLoading"
            clearable
            reserve-keyword
            filterable
            placeholder="please select"
          />
        </el-form-item>
        <el-form-item label="Payment Claim Status">
          <el-select v-model="filter.receiptClaimStatus" filterable clearable>
            <el-option
              v-for="item in advReceiptClaimStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Currency">
          <el-select v-model="filter.currency" filterable clearable>
            <el-option
              v-for="item in advReceiptClaimCurrencyList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Receipt Type">
          <el-select v-model="filter.receiptType" filterable clearable>
            <el-option
              v-for="item in advReceiptClaimReceiptTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Receipt Status">
          <el-select v-model="filter.receiptStatus" filterable clearable>
            <el-option
              v-for="item in advFullReceiptStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Receipt Date">
          <el-date-picker
            v-model="filter.receiptDate"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="daterange"
            clearable
            style="width:260px;"
            align="right"
            unlink-panels
            range-separator="to"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          />
        </el-form-item>
      </el-form>
    </template>
    <template #search-actions>
      <el-button type="primary" icon="el-icon-search" @click="handleSearch(1)">Search</el-button>
      <el-button
        v-if="isFinance()"
        type="primary"
        icon="el-icon-plus"
        @click="createDialogVisible = true"
        >Create Payment Receipt</el-button
      >
      <el-button
        v-if="isAdvPM()"
        type="primary"
        icon="el-icon-check"
        @click="handleForm('CLAIMED', 'POST_RECEIPT')"
        >Post Payment Receipt Claim</el-button
      >
      <el-button
        v-if="isAdvPM()"
        type="primary"
        icon="el-icon-check"
        @click="handleForm('CLAIMED', 'PRE_RECEIPT')"
        >Pre Payment Receipt Claim</el-button
      >
      <el-button
        v-if="isAdvPM()"
        type="primary"
        icon="el-icon-finished"
        @click="handleForm('CLAIM_CONFIRMED', 'POST_RECEIPT')"
        >Payment Receipt Confirm</el-button
      >
    </template>
    <template #table>
      <el-table
        v-loading="listLoading"
        ref="tableRef"
        :data="dataList"
        highlight-current-row
        row-key="id"
        :tree-props="{ children: 'children' }"
        @sort-change="handleSort"
      >
        <el-table-column
          label="Date"
          prop="recordDate"
          align="center"
          width="120"
          key="recordDate"
        />
        <el-table-column
          label="Adv Receipt Claim Number"
          prop="advReceiptClaimNumber"
          align="center"
          width="250"
          key="advReceiptClaimNumber"
        />
        <el-table-column
          label="Adv Company Platform"
          prop="advCompanyPlatform"
          align="center"
          width="180"
          key="companyPlatform"
        />
        <el-table-column
          label="Adv Entity"
          prop="advEntity"
          align="center"
          width="170"
          show-overflow-tooltip
          key="advEntity"
        />
        <el-table-column label="PM" prop="pmName" align="center" width="140" key="pmName" />
        <el-table-column label="BD" prop="bdName" align="center" width="140" key="bdName" />
        <el-table-column
          label="Adv Revenue"
          prop="advRevenue"
          align="center"
          width="150"
          key="advRevenue"
        />
        <el-table-column
          label="Adv Confirmed Amount"
          prop="advConfirmedAmount"
          align="center"
          width="220"
          key="advConfirmedAmount"
        />
        <el-table-column
          label="Adv Hedge Amount"
          prop="advHedgeAmount"
          align="center"
          width="200"
          key="advHedgeAmount"
        />
        <el-table-column
          label="Finance Receivable Amount"
          prop="financeReceivableAmount"
          align="center"
          width="240"
          key="financeReceivableAmount"
        />
        <el-table-column
          label="Finance Received Amount"
          prop="financeReceivedAmount"
          align="center"
          width="240"
          key="financeReceivedAmount"
        />
        <el-table-column label="Currency" prop="currency" align="center" width="140" key="currency">
          <template #default="scope">
            {{ getEnumLabel(advReceiptClaimCurrencyList, scope.row.currency) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Receipt Type"
          prop="receiptType"
          align="center"
          width="140"
          key="receiptType"
        >
          <template #default="scope">
            {{ getEnumLabel(advReceiptClaimReceiptTypeList, scope.row.receiptType) }}
          </template>
        </el-table-column>
        <el-table-column
          label="HyperTap Entity"
          prop="hyperTapEntity"
          align="center"
          width="170"
          key="hyperTapEntity"
        >
          <template #default="scope">
            {{ getEnumLabel(hyperTapEntityList, scope.row.hyperTapEntity) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Receipt Date"
          prop="receiptDate"
          align="center"
          key="receiptDate"
          width="160"
        />
        <el-table-column
          label="Receipt Status"
          prop="receiptStatus"
          align="center"
          key="receiptStatus"
          width="160"
        >
          <template #default="scope">
            {{ getEnumLabel(advFullReceiptStatusList, scope.row.receiptStatus) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Receipt Claim Status"
          prop="receiptClaimStatus"
          align="center"
          key="receiptClaimStatus"
          width="180"
        >
          <template #default="scope">
            {{ getEnumLabel(advReceiptClaimStatusList, scope.row.receiptClaimStatus) }}
          </template>
        </el-table-column>
        <el-table-column label="Invoice Attachments" align="center" width="170">
          <template #default="scope">
            <attachment-popover-table
              @refresh-list="handleSearch"
              :file-list="scope.row.fileList"
              :file-business-type="'BANK_SLIP'"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="Finance Remark"
          prop="financeSubmitRemark"
          align="center"
          key="financeSubmitRemark"
          show-overflow-tooltip
          width="180"
        />
        <el-table-column
          label="PM Confirm Remark"
          prop="pmConfirmRemark"
          align="center"
          key="pmConfirmRemark"
          width="180"
        />
        <el-table-column
          label="PM Audit Remark"
          prop="pmAuditRemark"
          align="center"
          key="pmAuditRemark"
          width="180"
        />
        <el-table-column
          label="Create Time"
          prop="createTime"
          align="center"
          key="createTime"
          width="160"
        />
        <el-table-column
          label="Create By"
          prop="createBy"
          align="center"
          key="createBy"
          width="160"
        />
        <el-table-column
          label="Update Time"
          prop="updateTime"
          align="center"
          key="updateTime"
          width="160"
        />
        <el-table-column
          label="Update By"
          prop="updateBy"
          align="center"
          key="updateBy"
          width="160"
        />
      </el-table>
    </template>
    <template #pagination>
      <pagination
        class="pagePanel"
        :pageTotal="total"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        :pageSize="filter.pageSize"
        :currentPage="filter.page"
      />
    </template>
    <template #dialog>
      <adv-payment-receipt-create-form
        :createDialogVisible.sync="createDialogVisible"
        @refresh-list="handleSearch"
      />
      <adv-payment-receipt-confirm-form
        :confirmDialogVisible.sync="confirmDialogVisible"
        :receipt-claim-status="receiptClaimStatus"
        :receipt-type="confirmFormReceiptType"
        @refresh-list="handleSearch"
      />
    </template>
  </base-list-layout>
</template>

<style scoped lang="scss">
  /* 为所有等级大于0的行添加样式 */
  ::v-deep .el-table__row[class*='el-table__row--level-']:not(.el-table__row--level-0) {
    background-color: #f0f2f5;
  }
</style>
